/**
 * Transforms a number into a string with thousands notation
 * @param {Number} num input number
 * @returns {String} input number with thousands notation
 * @example
 * 1000 -> 1.000
 */
export default function integerWithThousandSeparator(num, sep = null) {
  if (!num || typeof num !== 'number') {
    return '0';
  }
  const separator = sep || '.';
  return Math.ceil(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}
